module.exports = __webpack_public_path__ + "media/images/nyc-9b5139d4064879d409c92495bd4c1352.jpg";